import axios from "axios";
import { STRATEGY_ACTION_TYPE } from "./Type";
import { BASEURL } from "../../utilites";

// ✅ GET Strategies (all strategies, used elsewhere)
const getStrategies = () => async (dispatch) => {
  try {
    dispatch({ type: STRATEGY_ACTION_TYPE.getStrategiesRequest });

    const { data } = await axios.get(`${BASEURL}/api/customstrategies?custom=true`); // Replace with your endpoint

    dispatch({
      type: STRATEGY_ACTION_TYPE.getStrategiesSuccess,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: STRATEGY_ACTION_TYPE.getStrategiesError,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ✅ GET Strategies by Form ID (for Tax Plan Generator)
const getStrategiesByFormId = (formId) => async (dispatch) => {
  try {
    dispatch({ type: STRATEGY_ACTION_TYPE.getStrategiesByFormIdRequest });

    const params = {};
    if (formId) {
      params.form_id = formId;
    }

    const { data } = await axios.get(`${BASEURL}/api/customstrategies`, { params });

    console.log("getStrategiesByFormId response:", data);

    dispatch({
      type: STRATEGY_ACTION_TYPE.getStrategiesByFormIdSuccess,
      payload: data,
    });
  } catch (error) {
    console.error("getStrategiesByFormId error:", error);
    dispatch({
      type: STRATEGY_ACTION_TYPE.getStrategiesByFormIdError,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ✅ DELETE Strategy by ID
const deleteStrategy = (id) => async (dispatch) => {
  try {
    dispatch({ type: STRATEGY_ACTION_TYPE.deleteStrategyRequest });

    await axios.delete(`${BASEURL}/api/customstrategies/${id}`); // Replace with your backend endpoint

    dispatch({
      type: STRATEGY_ACTION_TYPE.deleteStrategySuccess,
      payload: id, // optional: could pass id to remove from list
    });
  } catch (error) {
    dispatch({
      type: STRATEGY_ACTION_TYPE.deleteStrategyError,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const customStrategy = {
  getStrategies,
  getStrategiesByFormId,
  deleteStrategy
}
